import { Buffer } from "buffer";

export const toFormstackFile = async file => {
    window.Buffer = window.Buffer || Buffer;
    return `${file.name};${window.Buffer.from(await file.arrayBuffer()).toString("base64")}`;
}
